export const AMBASSADOR_IMAGE =
  'https://cdn.magicpatterns.com/uploads/mvVeQeoBUWCtVnq6cRXWSM/6005674533056089326_(1).jpg'

/** Crop focus so the robot's face is centered inside circular avatars. */
export const AMBASSADOR_FACE_POSITION = '24% 22%'

/** Circular ambassador avatar (already cropped to a circle). */
export const AMBASSADOR_AVATAR =
  'https://cdn.magicpatterns.com/uploads/iSohR1cEhwrCYUeJJP7XDh/ChatGPT_Image_Aug_5,_2026,_04_59_06_PM.png'

export const BRAND_LOGOS = [
  {
    name: 'Whitelab',
    src: 'https://cdn.magicpatterns.com/uploads/hWtyzSCu1qjD6Z2Kd3Vjfw/brand_imageXr8T.png',
  },
  {
    name: 'Scarlett',
    src: 'https://cdn.magicpatterns.com/uploads/gu7FhkkwuWvrwmLm1SNKnS/Screenshot_2026-08-03_at_16.46.00.png',
  },
  {
    name: 'Skintific',
    src: 'https://cdn.magicpatterns.com/uploads/iSCugWuW2pbX3SpFKww6Li/Screenshot_2026-08-04_at_12.16.32.png',
  },
  {
    name: 'Oemah Herborist',
    src: 'https://cdn.magicpatterns.com/uploads/nkTMGSnuAYY94LqWVDWeTv/Screenshot_2026-08-04_at_12.06.57.png',
  },
  {
    name: 'Wardah',
    src: 'https://cdn.magicpatterns.com/uploads/rzGB8C3PJtexmhhCs35Daw/wardah.png',
  },
]
